export default __webpack_public_path__ + "static/media/Budget-Tracker.a66e3dc3.JPG";